import {create} from 'zustand'

type NotificationsPanelStore = {
    isOpen: boolean
    open: () => void
    close: () => void
}

/**
 * Global UI state for the notifications panel.
 *
 * Lifted out of NotificationButton's local state because the button lives inside Header,
 * which is rendered independently by each route, while the work-context bar is mounted once
 * in PrivateLayout and still has to be able to reopen the panel ("Torna alle notifiche").
 * Not persisted: the panel always starts closed on a fresh session.
 */
export const useNotificationsPanelStore = create<NotificationsPanelStore>()(set => ({
    isOpen: false,
    open: () => set({isOpen: true}),
    close: () => set({isOpen: false})
}))
